import {
  createStyles,
  Typography,
  withStyles,
  type WithStyles,
} from "@material-ui/core";
import { useTranslations } from "adapters/i18n";
import SelectDropdown from "components/SelectDropdown";
import React from "react";
import type { LivestockInfoFromFarm } from "shared/types";

type GoalColumnCellProps = {
  onChange: (goalId: number | null, row: LivestockInfoFromFarm) => void;
  options: Array<{ label: string; value: number }>;
  row: LivestockInfoFromFarm;
  value: number | null;
} & WithStyles<typeof styles>;

function GoalColumnCell({
  classes,
  onChange,
  options,
  row,
  value,
}: GoalColumnCellProps) {
  const { t } = useTranslations();

  const label = value != null ? t("common:goal") : t("common:commands.select");

  const sortedOptions = [...options].sort((a, b) =>
    a.label.localeCompare(b.label)
  );

  const handleChange = (value: number | null) => {
    onChange(value, row);
  };

  return (
    <div className={classes.root}>
      <SelectDropdown
        aria-label={label}
        className={classes.select}
        data-testid="lot-goal-select"
        isClearable={true}
        label={{ text: label }}
        onChange={handleChange}
        options={sortedOptions}
        value={value}
      />

      <Typography
        className={classes.text}
        component="span"
        data-testid="lot-goal-text"
      >
        {sortedOptions.find((option) => option.value === value)?.label ?? "-"}
      </Typography>
    </div>
  );
}

const styles = () =>
  createStyles({
    root: {
      alignItems: "center",
      display: "flex",
      height: "84px",
      maxWidth: "300px",
    },
    select: {
      minWidth: "200px",
      "@media print": {
        display: "none",
      },
    },
    text: {
      display: "none",
      "@media print": {
        display: "block",
        fontSize: "10px",
      },
    },
  });

export default withStyles(styles)(GoalColumnCell);
